export const EMI_TOAST_ERROR_TITLE = "Something went wrong. Please try again.";
